// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  text-align: center;
  border-bottom: none !important; /* quitar línea de Bootstrap debajo del header */
  padding-bottom: 0.5rem;
}

.modal-header::after {
  content: '';
  display: block;
  width: 90px;              /* línea más corta centrada */
  height: 1px;
  background: #e6e6e6;
  margin: 8px auto 10px;    /* separación cómoda del título/subtítulo */
}

.modal-header .modal-title,
.modal-header .modal-subtitle {
  text-align: center;
  width: 100%;
}

/* Alinear opciones a la izquierda en móvil (como en diseño esperado) */
@media screen and (max-width: 480px) {
  .form-check {
    text-align: left !important;
  }
  .form-check-input {
    float: left !important;
    margin-right: 10px !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/app/components/modal-kyc/kyc-survey/kyc-survey.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8BAA8B,EAAE,gDAAgD;EAChF,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW,eAAe,6BAA6B;EACvD,WAAW;EACX,mBAAmB;EACnB,qBAAqB,KAAK,2CAA2C;AACvE;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;AACb;;AAEA,uEAAuE;AACvE;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;AACF","sourcesContent":[".modal-header {\n  text-align: center;\n  border-bottom: none !important; /* quitar línea de Bootstrap debajo del header */\n  padding-bottom: 0.5rem;\n}\n\n.modal-header::after {\n  content: '';\n  display: block;\n  width: 90px;              /* línea más corta centrada */\n  height: 1px;\n  background: #e6e6e6;\n  margin: 8px auto 10px;    /* separación cómoda del título/subtítulo */\n}\n\n.modal-header .modal-title,\n.modal-header .modal-subtitle {\n  text-align: center;\n  width: 100%;\n}\n\n/* Alinear opciones a la izquierda en móvil (como en diseño esperado) */\n@media screen and (max-width: 480px) {\n  .form-check {\n    text-align: left !important;\n  }\n  .form-check-input {\n    float: left !important;\n    margin-right: 10px !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
